// src/api/posts.js
import api from './axios';

export const fetchPosts = (page = 1, search = '', category = null, authorId = null) =>
  api.get('/api/posts/', {
    params: {
      page,
      search,
      ...(category && { category }),
      ...(authorId && { author_id: authorId }),
    },
  });

// 게시글 상세 조회: confirm=true 이면 ?confirm=1 파라미터 포함
export const fetchPostView = (postId, confirm = false) =>
  api.get(`/api/posts/${postId}/`, {
    params: confirm ? { confirm: 1 } : {},
  });

export const createPost = (data) => api.post('/api/posts/create/', data);
export const editPost = (postId, data) => api.post(`/api/posts/${postId}/edit/`, data);
export const deletePost = (postId) => api.delete(`/api/posts/${postId}/`);

export const toggleLike = (postId) =>
  api.post(`/api/interactions/posts/${postId}/toggle-like/`);

export const toggleBookmark = (postId) =>
  api.post(`/api/interactions/posts/${postId}/toggle-bookmark/`);

export const fetchLikeStatus = (postId) =>
  api.get(`/api/interactions/posts/${postId}/like-status/`);

export const fetchBookmarkStatus = (postId) =>
  api.get(`/api/interactions/posts/${postId}/bookmark-status/`);
